import React from "react";

function AdminSettings() {
  return <div>AdminSettings</div>;
}

export default AdminSettings;
